<template>
  <div class="shell">
    <header-component v-if="!inFrame"></header-component>
    <div class="content-area" :class="{ embedded: inFrame }">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <footer-component v-if="!inFrame"></footer-component>
    <!-- Vue 3 overlay: full page, bound to spinnerShown -->
     <loading v-if="spinnerShown"
          :active="true"
          :is-full-page="true"
          :can-cancel="false" />
    <div id="overlay"></div>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import Header from './header';
  import Footer from './footer';
  import Title from './title';

  export default {
    name: 'AppRoot',
    components: {
      'header-component': Header,
      'footer-component': Footer,
      'loading': Loading,
      'vue-title': Title
    },
    computed: {
      inFrame() {
        let inFrame;
        try { inFrame = window.self !== window.top; } catch (e) { inFrame = true; }
        return inFrame && this.$displayMode === "popup";
      },
      spinnerShown() {
        // Re-enable the store-driven spinner when ready
        return this.$store.state.pendingRequests > 0;
      }
    },
    async mounted() {
      // Initialize locale but do not gate rendering
      try {
        const fallback = this.$i18n?.fallbackLocale;
        if (fallback) {
          await this.setLocale(fallback);
        }
      } catch (e) {
        console.warn('locale init skipped:', e);
      }
    }
  };
</script>

<style>
  .spinner-container {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>